import Vue from 'vue';

export default {

  init: (state, { host, currentLocale, locales, subdomain, subdomainsEnabled }) => {
    state.host = host;
    state.currentLocale = currentLocale;
    state.locales = locales,
    state.subdomain = subdomain,
    state.subdomainsEnabled = subdomainsEnabled
  },

  setCategories: (state, { categories }) => {
    state.categories = categories;
  },

  setShop: (state, { shop }) => {
    state.shop = shop;
  },

  setShopCoupons: (state, { shopCoupons, shopCouponsCount, shopFiltersCount }) => {
    state.shopCoupons = shopCoupons;
    state.shopCouponsCount = shopCouponsCount;
    if (shopFiltersCount) {
      state.shopFiltersCount = shopFiltersCount;
    }
  },

  pushShopCoupons: (state, { shopCoupons }) => {
    state.shopCoupons = [...state.shopCoupons, ...shopCoupons];
  },

  setShopCouponsExpired: (state, { shopCouponsExpired }) => {
    state.shopCouponsExpired = shopCouponsExpired;
  },

  setShopCoupon: (state, { shopCoupon }) => {
    state.shopCoupon = shopCoupon;
  },

  setPopularShops: (state, { shop }) => {
    state.popularShops = shop;
  }

}